import { render, staticRenderFns } from "./CampaignSetupPixelsListItemSkeleton.vue?vue&type=template&id=39174923&scoped=true&"
import script from "./CampaignSetupPixelsListItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsListItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsListItemSkeleton.vue?vue&type=style&index=0&id=39174923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39174923",
  null
  
)

export default component.exports